<template>
    <v-card>
        <v-card-title>
            <v-layout class="title">
                {{ $i18n.t('insertIndexes') }}

                <v-spacer/>

                <v-btn @click="$store.commit('setInsertIndexesDialog', false)">
                    {{ $t('cancel') }}
                    <v-icon right>clear</v-icon>
                </v-btn>
                <v-btn @click="submit" class="ml-3" color="teal">
                    {{ $t('save') }}
                    <v-icon right>done</v-icon>
                </v-btn>
            </v-layout>
        </v-card-title>

        <v-card-text>
            <v-container grid-list-xl>
                <v-expand-transition>
                    <v-card v-show="makingDone" height="121" class="mx-auto mb-4">
                        <v-alert v-show="makingDone" outlined type="warning">
                            <v-layout row>
                                <div  class="my-2 mx-4">
                                    {{ $i18n.t('confirmMakeDone') }}
                                </div>
                                <v-spacer/>
                                <v-btn @click="makeTestDone" color="orange" class="mr-4 mb-4">
                                    {{ $t('accept') }}
                                    <v-icon right>done</v-icon>
                                </v-btn>
                                <v-btn @click="makingDone = false" class="mr-4">
                                    {{ $t('cancel') }}
                                </v-btn>
                            </v-layout>
                        </v-alert>
                    </v-card>
                </v-expand-transition>


                <v-form ref="form" @submit="submit">
                    <v-row class="black--text body-2">
                        <v-flex xs3 class="mt-4 py-auto">
                            {{ $i18n.t('students') }}
                        </v-flex>
                        <v-flex xs3 class="mt-2 px-7">
                            <v-text-field v-model="students" :rules="studentsRules" dense outlined class="caption"/>
                        </v-flex>
                    </v-row>

                    <v-divider/>

                    <v-row justify="center">
                        <v-col cols=8>
                            <v-simple-table>
                                <tbody>
                                    <tr>
                                        <th class="text-center">
                                            ID
                                        </th>
                                        <th class="text-center">
                                            {{  $i18n.t('position') }}
                                        </th>
										<th class="text-center title font-weight-light">
											<v-tooltip open-on-hover bottom>
												<template v-slot:activator="{ on }">
													<div v-on="on">
														{{ $i18n.t('difficulty') }}
													</div>
												</template>
												<span>{{ $i18n.t('difficultyTooltip') }}</span>
											</v-tooltip>
										</th>

										<th class="text-center title font-weight-light">
											<v-tooltip open-on-hover bottom>
												<template v-slot:activator="{ on }">
													<div v-on="on">
														{{ $i18n.t('discrimination') }}
													</div>
												</template>
												<span>{{ $i18n.t('discriminationTooltip') }}</span>
											</v-tooltip>
										</th>
                                    </tr>

                                    <tr v-for="formulation in getFormulationsByTest" :key="formulation.id" class="mb-n5 black--text body-2 text-center">
                                        <td>
                                            {{ formulation.questionId }}
                                        </td>
                                        <td>
                                            {{ formulation.position }}
                                        </td>
                                        <td align="center">
                                            <v-flex xs8 class="mt-2 mb-n5">
                                                <v-text-field v-model="formulation.difficulty" :rules="difficultyRules" dense outlined class="caption"/>
                                            </v-flex>
                                        </td>
                                        <td align="center">
                                            <v-flex xs8 class="mt-2 mb-n5">
                                                <v-text-field v-model="formulation.discrimination" :rules="discriminationRules" dense outlined class="caption"/>
                                            </v-flex>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-form>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { i18n } from '@/main.js' 

export default {
    data(){
        return {
            difficultyRules: [
                v => v != '' || '',
                v => v != null || '',
                v => !isNaN(v) || '',
                v => v >= 0 || '',
                v => v <= 100 || '',
            ],
            discriminationRules: [
                v => v != '' || '',
                v => v != null || '',
                v => !isNaN(v) || '',
                v => v >= 0 || '',
                v => v <= 1 || '',
            ],
            studentsRules: [
                v => v != '' || '',
                v => !isNaN(v) || '',
                v => v > 0 || '',
                v => v <= 999 || '',
            ],
        }
    },

    methods: {
        submit() {
            if (this.$refs.form.validate()){
                this.makingDone = true
            }
        },
        makeTestDone() {
            // Indexes are strings, because of user input. Cast to number
            for (const formulation of this.getFormulationsByTest) {
                formulation.difficulty = Number(formulation.difficulty)
                formulation.discrimination = Number(formulation.discrimination)
            }

            this.$store.dispatch('updateFormulations') // Add indexes
            .then(() => {
                this.$store.dispatch('updateTest') // Set students
            })
        }
    },

    computed:{
        ...mapGetters([
            'isLoading',
            'getInsertIndexesDialog',
            'getFormulationsByTest',
            'getTest',
            'getStudents',
            'isMakingTestDone',
        ]),
        students: {
            get() { return this.getStudents },
            set(value) { this.$store.commit('setStudents', value) },
        },
        makingDone: {
            get() { return this.isMakingTestDone },
            set(value) { this.$store.commit('setMakingTestDone', value) }
        },
    },

    watch: {
        getInsertIndexesDialog() {
            this.$refs.form.resetValidation()
        }
    }
}
</script>
